import { render, staticRenderFns } from "./editPriceRegion.vue?vue&type=template&id=3c75b740"
import script from "./editPriceRegion.vue?vue&type=script&lang=js"
export * from "./editPriceRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports